import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initRegistry } from "@/data/generators";
import { initSentry } from "@/lib/sentry";
import { initPostHog } from "@/lib/analytics/init";
import { initDatadog } from "@/lib/apm/init";

// EXPAI-002: init Sentry before anything else so early errors are captured.
// No-op if VITE_SENTRY_DSN is not set.
initSentry();

// EXPAI-018: init PostHog product analytics. No-op if VITE_POSTHOG_KEY missing.
initPostHog();

// EXPAI-019: init Datadog APM/RUM. No-op without VITE_DD_APPLICATION_ID + VITE_DD_CLIENT_TOKEN.
initDatadog();

// Initialize synthetic data registry before first render so any
// component can read from `@/data` or `registry` immediately.
initRegistry();

createRoot(document.getElementById("root")!).render(<App />);

// ----------------------------------------------------------------------
// Service Worker registration (production only, never in Lovable preview)
// ----------------------------------------------------------------------
(function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  const isInIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();
  const host = window.location.hostname;
  const isPreviewHost =
    host.includes('id-preview--') ||
    host.includes('lovableproject.com') ||
    host.includes('lovable.app') ||
    host === 'localhost' ||
    host === '127.0.0.1';

  if (import.meta.env.DEV || isInIframe || isPreviewHost) {
    // Defensive cleanup if a previous SW slipped in during preview.
    navigator.serviceWorker.getRegistrations?.().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* SW failed — app still works without offline assets */
    });
  });
})();
